import { useMount } from 'react-use';

import { transferAccountTutorialStorageKey } from './TransferAccount.constants';

export const useTutorial = (openTour?: VoidFunction) => {
    useMount(() => {
        if (!openTour) {
            return;
        }

        const isTutorialShown = localStorage.getItem(transferAccountTutorialStorageKey) === 'true';

        if (isTutorialShown) {
            return;
        }

        // Wait for the elements positions to stabilize
        setTimeout(() => {
            openTour();
            localStorage.setItem(transferAccountTutorialStorageKey, 'true');
        }, 300);
    });
};
